<template>
  <div :id='id' class='pros-icon' style='width:fit-content'></div>
</template>

<script>
  import { Icon } from '@printos/agnostic-icon';

  export default {
    props: {
      id: {
        type: String,
      },
      name: {
        type: String,
      },
      path: {
        type: String,
      },
      url: {
        type: String,
      },
      tooltip: {
        type: String,
      },
      className: {
        type: String,
      },
      theme: {
        type: String,
      },
      mode: {
        type: String,
      },
      constraint: {
        type: String,
      },
      size: {
        type: String,
      },
      color: {
        type: String,
      },
      solid: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      id: function(newVal) {
        this._printos.icon.$set({id: newVal});
      },
      name: function(newVal) {
        this._printos.icon.$set({name: newVal});
      },
      path: function(newVal) {
        this._printos.icon.$set({path: newVal});
      },
      url: function(newVal) {
        this._printos.icon.$set({path: newVal});
      },
      tooltip: function(newVal) {
        this._printos.icon.$set({tooltip: newVal});
      },
      className: function(newVal) {
        this._printos.icon.$set({className: newVal});
      },
      solid: function(newVal) {
        this._printos.icon.$set({solid: newVal});
      },
      theme: function(newVal) {
        this._printos.icon.$set({theme: newVal});
      },
      mode: function(newVal) {
        this._printos.icon.$set({mode: newVal});
      },
      constraint: function(newVal) {
        this._printos.icon.$set({constraint: newVal});
      },
      size: function(newVal) {
        this._printos.icon.$set({size: newVal});
      },
      color: function(newVal) {
        this._printos.icon.$set({color: newVal});
      },
      disabled: function(newVal) {
        this._printos.icon.$set({disabled: newVal});
      },
    },
    mounted() {
      this._printos = {};
      this._printos.icon = new Icon({
        target: this.$el,
        props: {
          id: this.id,
          name: this.name,
          path: this.path,
          url: this.url,
          tooltip: this.tooltip,
          className: this.className,
          theme: this.theme,
          mode: this.mode,
          constraint: this.constraint,
          size: this.size,
          solid: this.solid,
          color: this.color,
          disabled: this.disabled,
        },
      });
      // this._printos.icon.$on('click', event => {
      //   this.$emit('click', event.detail);
      // });
    },
    unmounted() {
      this._printos.icon.$destroy();
    },
  }
</script>
